import { Link } from "react-router-dom";
import { Mail, MapPin } from "lucide-react";
import { SocialButtons } from "@/components/SocialButtons";

export function Footer() {
  return (
    <footer className="bg-champagne-dark/50 border-t border-border" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <span className="font-heading text-2xl font-semibold text-charcoal">
              Journey With Joyce Lim
            </span>
            <p className="font-body text-charcoal-light leading-relaxed max-w-sm mt-4">
              Helping individuals and families understand and shift emotional, behavioral,
              and life patterns through an integrated approach.
            </p>
            <div className="flex items-center gap-3 mt-6">
              <a
                href="https://wa.me/6597946649"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="footer-whatsapp"
                className="bg-navy text-white px-5 py-2.5 rounded-full text-sm font-body font-semibold hover:bg-navy-light transition-all hover:scale-105"
              >
                WhatsApp Joyce
              </a>
            </div>
            <SocialButtons variant="icon-only" className="mt-4" />
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-charcoal mb-4">Explore</h4>
            <div className="flex flex-col gap-3">
              {[
                { to: "/about", label: "About Joyce" },
                { to: "/work-with-me", label: "Work With Me" },
                { to: "/journal", label: "Journal" },
                { to: "/blog", label: "Blog" },
                { to: "/contact", label: "Get in Touch" },
              ].map((l) => (
                <Link
                  key={l.to}
                  to={l.to}
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, '-')}`}
                  className="font-body text-sm text-charcoal-light hover:text-navy transition-colors"
                >
                  {l.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg font-semibold text-charcoal mb-4">Contact</h4>
            <div className="flex flex-col gap-3 text-sm font-body text-charcoal-light">
              <a href="mailto:happyjourneywithjoyce@gmail.com" className="flex items-center gap-2 hover:text-navy transition-colors">
                <Mail className="w-5 h-5 text-blue-grey flex-shrink-0" />
                <span>happyjourneywithjoyce@gmail.com</span>
              </a>
              <div className="flex items-center gap-2">
                <MapPin className="w-5 h-5 text-blue-grey flex-shrink-0" />
                <span>Singapore</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-6 border-t border-border flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="font-body text-xs text-charcoal-light">
            &copy; {new Date().getFullYear()} Journey With Joyce Lim. All rights reserved.
          </p>
          <Link
            to="/admin"
            data-testid="footer-admin-link"
            className="font-body text-xs text-charcoal-light/50 hover:text-charcoal-light transition-colors"
          >
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
}
